import firebase from 'firebase/app'
import 'firebase/auth'
import supportApi from '@/libs/support-api'
import { supportNavItem } from '@/navigation/vertical'

const POLL_MS = 60000
let timer = null

function refresh() {
  supportApi('get', '/stats')
    .then(response => {
      const counts = response.data
      const waiting = (counts.drafted || 0) + (counts.needs_human || 0)
      supportNavItem.tag = waiting > 0 ? String(waiting) : ''
    })
    .catch(() => {
      supportNavItem.tag = ''
    })
}

/** Keeps the menu badge on "Support" up to date while someone is signed in. */
export default function startSupportBadge() {
  firebase.auth().onAuthStateChanged(user => {
    clearInterval(timer)
    if (user) {
      refresh()
      timer = setInterval(refresh, POLL_MS)
    } else {
      supportNavItem.tag = ''
    }
  })
}
